import React, { createContext, useContext, useState, useCallback } from 'react';
import ErrorToast from '../components/ErrorToast';

const AIErrorContext = createContext();

export function AIErrorProvider({ children }) {
  const [error, setError] = useState(null);

  const showError = useCallback((error) => {
    setError(error);
  }, []);

  const clearError = useCallback(() => {
    setError(null);
  }, []);

  return (
    <AIErrorContext.Provider value={{ showError, clearError }}>
      {children}
      {error && <ErrorToast error={error} onClose={clearError} />}
    </AIErrorContext.Provider>
  );
}

export function useAIError() {
  return useContext(AIErrorContext);
} 